import { useMemo } from 'react';
import get from 'lodash/get';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

import Languages from '@ad-scripts/domain/models/languages/answer_languages';

export default function useLanguageOptions(languages) {
  return useMemo(
    () =>
      sortBy(
        map(languages, lang => ({
          value: lang,
          label: get(Languages, lang, ''),
        })),
        v => v.label
      ),
    [languages]
  );
}
